<template lang="pug">
  div(class="history")
    div(class="history-inner" :style="transform")
      history-item(v-for="(item, index) in items" :ref="index + 1" :item="item" :key="index + 1" @waypoint="waypoint")
</template>

<script>
import historyItem from './history-item'
export default {
  name: 'history',
  props: ['items', 'selected'],
  data () {
    return {
      offset: 0,
      duration: 0
    }
  },
  computed: {
    transform () {
      return {
        transform: 'translateX(-' + this.offset + 'px)',
        transition: 'transform ' + this.duration + 'ms linear'
      }
    },
    factor () {
      return (this.selected - 1) * 100
    },
    speed () {
      return 1000
    }
  },
  methods: {
    getOffset () {
      let selection = this.$refs[this.selected][0].$el.offsetLeft
      return selection
    },
    setOffset (pixels) {
      this.offset = pixels
    },
    waypoint (id) {
      console.log(id)
      this.$emit('waypoint', id)
    }
  },
  watch: {
    selected (from, to) {
      this.duration = Math.abs(from - to) * 1000
      this.setOffset(this.getOffset())
    }
  },
  components: {
    historyItem
  }
}
</script>

<style lang="stylus">
.history
  height: 100%
  position: relative;
  overflow: hidden
  &-inner
    position: absolute;
    top: 0
    left: 0
    bottom: 0
    display: flex
</style>



// WEBPACK FOOTER //
// src/components/history.vue